import { FileCategory, getFileCategory } from "../../../utils/file.utils";
import { Spin } from "antd";
import ImageViewer from "../ImageViewer/index.js"
const FileViewer = ({ file, url, loading }) => {

    const fileType = getFileCategory(file?.filename);
    const fileName = file?.filename;

    if (loading) {
        return (
            <div className="flex justify-center items-center h-[846px]">
                <Spin size="large" />
            </div>
        );
    }

    switch (fileType) {
        case FileCategory.Image:
            return (
                <ImageViewer src={url}
                             alt={fileName}
                             className="max-w-full max-h-[846px] object-contain" />
            );

        case FileCategory.Pdf:
            return (
                <iframe
                    src={url}
                    title="PDF Viewer"
                    className="w-full h-[846px]"
                />
            );

        case FileCategory.Word:
            return (
                <iframe
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        url
                    )}`}
                    title="Office Viewer"
                    className="w-full h-[846px]"
                />
            );

        case FileCategory.Zip:
            return (
                <div className="flex flex-col items-center justify-center h-[846px] text-center">
                    <p className="font-semibold mb-2">ZIP archive</p>
                    <p className="text-sm text-gray-500 mb-4">
                        Preview not supported
                    </p>
                    <a
                        href={url}
                        download={fileName}
                        className="text-blue-600 underline"
                    >
                        Download ZIP
                    </a>
                </div>
            );

        default:
            return (
                <div className="flex items-center justify-center h-[846px] text-gray-500">
                    Unsupported file type
                </div>
            );
    }
};

export default FileViewer;
